module.exports = __webpack_public_path__ + "img/image40.a533ee5d.png";